import { Query } from '@skylab-shared/core';
import { ExportQueryParameters } from './export-query.parameters';
import { ExportResult } from './export-query.result';

export class ExportQuery<TResult extends ExportResult> extends Query<TResult> {
    public constructor(public readonly parameters: ExportQueryParameters) {
        super();
    }
}
